export enum AvailableMenus {
  'for_review' = 'for_review',
  'pending' = 'pending',
  'journal_entries' = 'journal_entries',
  'reconciled' = 'reconciled',
}

export enum AvailableTabs {
  'reconcile' = 'reconcile',
  'match' = 'match',
  'categorize' = 'categorize',
  'no_match' = 'no_match',
}

export enum AvailableSections {
  'dashboard' = 'dashboard',
  'reconciliation' = 'reconciliation',
  'reporting' = 'reporting',
}
